export default __webpack_public_path__ + "static/media/f_wdt_c_4_5.7733e548.mp3";